/// <reference types="react-scripts" />
import { Box, Chip, ListItem, Typography } from "@mui/material";
import * as React from "react";
import { IFrontToDoItem } from "source/models/front/frontToDoItem";
import { ToDoItemLinkType } from "ui/Scripts/source/models/enums";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";

export interface IDashboardToDoItemProp {
    toDoItem: IFrontToDoItem;
    onClick: (e: any, toDoItem: IFrontToDoItem) => void;
}

export const DashboardToDoItem = (props: IDashboardToDoItemProp) => {
    const item = props.toDoItem;
    return (
        <ListItem sx={{ padding: item.important ? "6px 16px" : "8px 16px", cursor: "pointer" }} onClick={(e) => props.onClick(e, item)}>
            <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
                <Box display="flex" alignItems="center" >
                    {(item.linkType === ToDoItemLinkType.List
                        ? <FormatListBulletedIcon sx={{ marginRight: ".4rem", color: "primary.main", fontSize: "small" }} />
                        : (item.linkType === ToDoItemLinkType.Report
                            ? <InsertChartOutlinedIcon sx={{ marginRight: ".4rem", color: "primary.main", fontSize: "small" }} />
                            : null
                        )
                    )}
                    <Typography color="text.secondary">{item.title}</Typography>
                </Box>
                {item.important
                    ? (
                        <Chip label={item.amount.toString(10)} size="small" variant="filled" color="error" sx={{ marginRight: "-8px" }} />
                    )
                    : (
                        <Typography>{item.amount.toString(10)}</Typography>
                    )}
            </Box>
        </ListItem>
    );
};